import { IProductListEntity } from '../entitites/product-list.entity';

export class ProductListDto {
  products: Array<string>;

  constructor(entity: IProductListEntity) {
    this.products = entity.products;
  }
}
